import { render, staticRenderFns } from "./GetTO.vue?vue&type=template&id=07cafab3&scoped=true"
import script from "./GetTO.vue?vue&type=script&lang=js"
export * from "./GetTO.vue?vue&type=script&lang=js"
import style0 from "./GetTO.vue?vue&type=style&index=0&id=07cafab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cafab3",
  null
  
)

export default component.exports